import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"
import React, { Dispatch, SetStateAction, useContext, useEffect, useState } from "react"
import CancelButton from "../../../../../../../components/buttons/CancelButton/CancelButton"
import { ValidateButton } from "../../../../../../../components/buttons/ValidateButton/ValidateButton"
import { Transition } from "../../../../../../../components/dialog/BaseDialog"
import { BaseSelectInput } from "../../../../../../../components/inputs/select-input/BaseSelectInput"
import { ProjectContext } from "../../../../../../../core/context/project/ProjectContext"
import { ProjectStatusEnum, projectStatusEnumLabels } from "../../../../../../../core/enum/projectStatusEnum"
import { enumToSelectOptions } from "../../../../../../../core/services/helper-service"

type IProps = {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
}

export function UpdateProjectStatusDialog({ open, setOpen }: Readonly<IProps>): React.JSX.Element {
  const { project, handleUpdateProjectStatus } = useContext(ProjectContext)

  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
  const [selectedProjectStatus, setSelectedProjectStatus] = useState<ProjectStatusEnum | undefined>(project?.status)

  useEffect(() => {
    setSelectedProjectStatus(project?.status)
  }, [project?.status])

  function onClose(): void {
    setOpen(false)
    setSelectedProjectStatus(project?.status)
  }

  return (
    <Dialog open={open} onClose={() => onClose()} fullWidth maxWidth="md" TransitionComponent={Transition}>
      <DialogTitle>{`Mise à jour du status de "${project?.name}"`}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Modifiez l'état de votre projet selon son avancement. Veuillez noter qu'en passant au statut "Archivé", l'accès
          sera limité à la lecture seule, et aucune modification ne sera possible.
        </DialogContentText>
        <DialogContent id="updateBsProjectStatus" sx={{ pl: 0 }}>
          <BaseSelectInput
            id="status"
            label="Statut"
            selectedOption={selectedProjectStatus}
            options={enumToSelectOptions(ProjectStatusEnum, projectStatusEnumLabels).filter(
              (selectedOption) =>
                selectedOption.value !== ProjectStatusEnum.DELETED && selectedOption.value !== ProjectStatusEnum.ALL
            )}
            mode="direct"
            handleChange={(e) => setSelectedProjectStatus(e)}
          />
        </DialogContent>
      </DialogContent>
      <DialogActions>
        <CancelButton onClick={() => onClose()} label="Annuler" />
        <ValidateButton
          onClick={() => {
            if (project && selectedProjectStatus) {
              setIsSubmitting(true)
              handleUpdateProjectStatus(selectedProjectStatus).then(() => {
                setIsSubmitting(false)
                onClose()
              })
            }
          }}
          label="Valider"
          isSubmitting={isSubmitting}
        />
      </DialogActions>
    </Dialog>
  )
}
